import { CouponBanner } from '../components/CouponBanner';
import { useCouponBannerService } from '../services/useCouponService';

export interface CouponBannerContainerProps {}

export const CouponBannerContainer: React.FC<React.PropsWithChildren<CouponBannerContainerProps>> = () => {
  const { noticeText } = useCouponBannerService();

  return <CouponBanner noticeText={noticeText} />;
};
